import React from "react";
import { View, Text, Platform } from "react-native";
import { getCreditCategory } from "../VideosListScreen/utils";
import { ActionsContainer, Button, Modal } from "../../components";
import LottieView from "lottie-react-native";
interface SuccessModalProps {
  assessmentResult: {
    score: number;
    creditCategory: string;
  };
  onCloseAssessment: () => void;
  visible: boolean;
}

const Footer = ({ onCloseAssessment }: { onCloseAssessment(): void }) => {
  return (
    <View className={`${Platform.OS === "web" ? "mx-16" : ""} mb-12 mt-2`}>
      <ActionsContainer hideBorder>
        <Button mode="secondary" onPress={onCloseAssessment} className="w-full">
          Close
        </Button>
      </ActionsContainer>
    </View>
  );
};

export default function SuccessModal({ assessmentResult, visible, onCloseAssessment }: SuccessModalProps) {
  return (
    <Modal
      {...{
        visible,
        onDismiss: onCloseAssessment,
        title: "",
        fullScreen: false,
        FooterComponent: <Footer onCloseAssessment={onCloseAssessment} />,
      }}
    >
      <View testID="successModal" className="flex-1 items-center bg-white pt-8 mt-16">
        <View className="w-40 h-40 items-center">
          <LottieView
            style={{ flex: 1, width: "100%", height: "100%" }}
            autoPlay
            loop={false}
            source={require("../../../assets/lottie-icons/award.json")}
          />
        </View>
        <Text className="text-title-2 font-700 mt-10 text-center">Nice Work!</Text>
        <Text className="text-regular-normal font-400 mt-6 mx-8 text-center">
          You successfully passed the assessment with a score of {assessmentResult.score}%.
        </Text>
        <Text className="text-regular-normal font-400 mt-6 mx-8 text-center">
          1 PDR Credit for {getCreditCategory(assessmentResult.creditCategory)} has been added to your PDR totals.
        </Text>
      </View>
    </Modal>
  );
}
